import React from 'react';

import { useQuery } from '@apollo/react-hooks';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { GET_ALL_AREAS } from '../../graphql/videos';
import { BREAKPOINTS_VALUES } from '../../theme';
import { Categories } from '../Categories';
import { LazyLoadImage } from '../LazyloadImage';
import { Loader } from '../Loader';
import useStyles from './styles';

const AreasBlock = ({ data: areasData, preventLoader }) => {
  const background = areasData?.background;
  const classes = useStyles(background)();
  const { t } = useTranslation();

  const { data, loading, error } = useQuery(GET_ALL_AREAS);

  if (loading) {
    return preventLoader ? null : <Loader />;
  }

  if (error) {
    return (
      <div>
        {t('error.error')}: {error?.message}
      </div>
    );
  }

  const areas = data?.listBaseVideoCategories;
  const areaBlockHeading = areasData?.heading;

  return (
    <Container
      className={cx(
        'catalogue-of-categories-block',
        classes.container,
        background === 'Dark' ? 'dark-block' : 'light-block',
      )}
    >
      <Typography variant="h2" component="h2" align="center" className={classes.heading}>
        {areaBlockHeading}
      </Typography>

      <Box className={classes.itemsWrapper}>
        {areas &&
          areas.map((item) => {
            const title = item?.title;
            const imgUrl = item?.image_url;

            return (
              <div className={cx('categories-area', classes.item)} key={item.title}>
                <div className={classes.imgWrapper}>
                  <LazyLoadImage
                    className={classes.itemImg}
                    path={imgUrl}
                    draggable={false}
                    alt={title}
                    srcset={[
                      { width: 350, height: 210, crop: 'maintain_ratio' },
                      { width: 770, height: 300, crop: 'maintain_ratio' },
                      { width: 170, height: 300, crop: 'maintain_ratio' },
                      { width: 190, height: 250, crop: 'maintain_ratio' },
                    ]}
                    sizes={`(max-width:${BREAKPOINTS_VALUES['sm']}px) 350px, (max-width:${BREAKPOINTS_VALUES['md']}px) 770px, (max-width:${BREAKPOINTS_VALUES['lg']}px) 170px, 190px`}
                  />
                </div>

                <div className={classes.itemContent}>
                  <div className={classes.itemTitle}>{title}</div>

                  <Categories parentId={item.id} />
                </div>
              </div>
            );
          })}
      </Box>
    </Container>
  );
};

export default AreasBlock;
